/*
 * @Description: 数据看板 actions type
 */

export enum AnalysisActionTypes {
  ACTION_ANALYSIS_SCREENFULL = 'ACTION_ANALYSIS_SCREENFULL',
  ACTION_ANALYSIS_SCREENTHEM = 'ACTION_ANALYSIS_SCREENTHEM',
}
